import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { AttendanceDashboard } from './features/attendance/AttendanceDashboard';
import { StudentManagement } from './features/students';
import { CaseManagement } from './features/cases/CaseManagement';
import { HomeVisitManagement } from './features/visits/HomeVisitManagement';
import { ResourceDirectory } from './features/resources/ResourceDirectory';
import { DataInsights } from './features/insights/DataInsights';
import { ComplianceCenter } from './features/compliance/ComplianceCenter';
import { TrainingCenter } from './features/training';
import { EventManagement } from './features/events/EventManagement';
import { FormManagement } from './features/forms/FormManagement';
import { MeetingsComponent } from './features/meetings';

export const AppRoutes: React.FC = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3, mt: { xs: 7, sm: 8 } }}>
      <Routes>
        <Route path="/" element={<AttendanceDashboard />} />
        <Route path="/students" element={<StudentManagement />} />
        <Route path="/cases" element={<CaseManagement />} />
        <Route path="/visits" element={<HomeVisitManagement />} />
        {/* <Route path="/forms/*" element={<FormManagement />} /> */}
        <Route path="/resources" element={<ResourceDirectory />} />
        <Route path="/insights" element={<DataInsights />} />
        <Route path="/compliance" element={<ComplianceCenter />} />
        <Route path="/training" element={<TrainingCenter />} />
        <Route path="/events" element={<EventManagement />} />
        <Route path="/meetings" element={<MeetingsComponent />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  );
};